import { IDisplayTableModel } from '../../models/display-table-model'
import { FilterByModel } from '../../models/filterby-model'
import { DisplayTableView } from '../../shared/display-table-view'
import { AggregateHandlerResultModel } from './models/aggregate-handler-result-model'
import { FundCategoryModel } from './models/fund-category-model'
import { IFilterState } from './models/ifilter-state'

export abstract class AbstractFilterProcess {
  public applyFilter(
    displayTableContentAry: IDisplayTableModel[],
  ): DisplayTableView {
    //  Step 1 : To execute all handlers, specific to filter selections
    const aggregateHandlerResultModel = this.executeFilterHandlers(
      this.getFilterState().getAllFilterSelections(),
    )
    const displayTableContentMap = this.covertDisplayTableContentToMap(
      displayTableContentAry,
    )

    // Step 2:  Apply fund rules over funds and map display table content
    const fundCategoryModelList = this.applyAggregateRules(
      aggregateHandlerResultModel,
      displayTableContentMap,
    )
    this.setAvailableCategoryLvl1Names(fundCategoryModelList)
    // Step 3: Generate the view
    return this.generateView(fundCategoryModelList)
  }

  protected abstract generateView(
    categoryModelList: FundCategoryModel[],
  ): DisplayTableView

  protected abstract getFilterState(): IFilterState
  protected abstract executeFilterHandlers(
    filterSelectionsAry: string[],
  ): AggregateHandlerResultModel
  protected abstract covertDisplayTableContentToMap(
    displayTableContentAry: IDisplayTableModel[],
  ): Map<string, IDisplayTableModel>
  protected abstract applyAggregateRules(
    aggregateHandlerResultModel: AggregateHandlerResultModel,
    displayTableContentMap: Map<string, IDisplayTableModel>,
  ): FundCategoryModel[]
  abstract setSearchText(searchText: string): void
  protected abstract setAvailableCategoryLvl1Names(
    fundCategoryModelList: FundCategoryModel[],
  ): void
  abstract getAvailableCategoryLvl1Names(): FilterByModel
}
